import { defineMessages } from 'react-intl';

export default defineMessages({
    generalCoverages: {
        id: 'quoteandbind.RecMarProduct.views.coverages.GeneralCoverages',
        defaultMessage: 'Coverages',
    },
    coverages: {
        id: 'quoteandbind.RecMarProduct.views.coverages.Coverage',
        defaultMessage: 'Coverage  {count}',
    },
    covAccordion: {
        id: 'quoteandbind.RecMarProduct.views.coverages.Coverages',
        defaultMessage: 'Coverages'
    }
});
